<template>
  <g
    id="ic_doubleRight"
    transform="translate(-734 -389)"
  >
    <rect
      id="Rechteck_813"
      data-name="Rechteck 813"
      width="24"
      height="24"
      transform="translate(734 389)"
      fill="none"
    />
    <path
      id="Pfad_1560"
      data-name="Pfad 1560"
      d="M10.52,39.36a1.394,1.394,0,0,0,.92-.38q.44-.38.48-.42a35.777,35.777,0,0,1,3.94-3.28,37.517,37.517,0,0,1,4.42-2.48,1.644,1.644,0,0,0,1.12-1.52.641.641,0,0,0-.4-.6q-3.64-2.16-5.2-3.28a45.629,45.629,0,0,1-3.96-3.32,2.3,2.3,0,0,0-1.36-.84.235.235,0,0,0-.2.12.569.569,0,0,0-.08.32,1.368,1.368,0,0,0,.24.64,39.443,39.443,0,0,0,2.94,4A34.29,34.29,0,0,0,16.08,31q.28.16.28.28,0,.08-.28.32a27.038,27.038,0,0,0-2.7,2.68,44.62,44.62,0,0,0-2.94,4.04.987.987,0,0,0-.24.56Q10.2,39.36,10.52,39.36Zm-8.44,0A1.394,1.394,0,0,0,3,38.98q.44-.38.48-.42a35.777,35.777,0,0,1,3.94-3.28,37.517,37.517,0,0,1,4.42-2.48,1.644,1.644,0,0,0,1.12-1.52.641.641,0,0,0-.4-.6q-3.64-2.16-5.2-3.28A45.629,45.629,0,0,1,3.4,24.08a2.3,2.3,0,0,0-1.36-.84.235.235,0,0,0-.2.12.569.569,0,0,0-.08.32,1.368,1.368,0,0,0,.24.64,39.444,39.444,0,0,0,2.94,4A34.29,34.29,0,0,0,7.64,31q.28.16.28.28,0,.08-.28.32a27.038,27.038,0,0,0-2.7,2.68A44.621,44.621,0,0,0,2,38.32a.987.987,0,0,0-.24.56Q1.76,39.36,2.08,39.36Z"
      transform="translate(734.24 369.76)"
      fill="#455667"
    />
  </g>
</template>
